<style lang="less" scoped>
  @import "../../../../style/theme.less";

  .input {
    border-radius: 50px;
    height: 25px;
    width: 25px;
    border: 3px solid @question-color;
    padding: 0;
    transition: all .1s @ease-in-out;

    &:hover { cursor: pointer; }

    &:focus {
      outline: 0;
    }

    &.active .icon {
      opacity: 1;
    }

    &.done {
      border: 3px solid @border-color-base;

      &.active {
        background-color: @border-color-base;
      }

      .icon {
        color: fade(@text-color, 50%);
      }
    }

    &:not(.done) {
      &.active, &:hover {
        background-color: @border-color-base;
      }
    }

    &&-1, &&-5 {
      height: 35px;
      width: 35px;

      &:not(.done) {
        &.active, &:hover {
          background-color: @question-color;
        }
      }
    }

    &&-3 .icon {
      color: fade(@text-color, 50%);
    }

    &&-2, &&-4 {
      height: 30px;
      width: 30px;

      &:not(.done) {
        &.active, &:hover {
          background-color: mix(@question-color, @component-background, 70%);
        }
      }
    }

    .icon {
      color: white;
      opacity: 0;
      font-weight: bold;
      transition: opacity .1s @ease-in-out;
    }
  }
</style>

<template>
  <div>
    <a-tooltip
      placement="bottom"
      :mouseEnterDelay="0.3"
    >
      <template slot="title">
        {{ tooltip }}
      </template>

      <button
        class="input"
        :class="[`input-${value}`, active ? 'active' : '', done ? 'done' : '']"
        @click="$emit('click', value)"
      >
        <a-icon type="check" class="icon" />
      </button>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'question',

  props: {
    value: Number,
    active: Boolean,
    done: Boolean,
    tooltip: String,
  },
};
</script>
